import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerPecNotifichePecModalComponent} from './worker-pec-notifiche-pec-modal';


export const WorkerPecNotifichePecModalModule: string = ng
  .module('worker-pec-notifiche-pec-modal', [
    'ui.bootstrap',
    uiRouter
  ])
  .component('workerPecNotifichePecModalComponent', WorkerPecNotifichePecModalComponent)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-pec-notifiche-pec-modal/worker-pec-notifiche-pec-modal.module.ts